module.exports = "/images/e6e86d345aba3760824bca83992e966a.png";